import { createApp } from "vue";
import FooterComponent from "./FooterComponent.vue";

const app = createApp({
  components: {
    "footer-component": FooterComponent,
  },
}).mount("#container-footer-component");
